import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export class Ourprojects extends Component {
    static displayName = Ourprojects.name;
    constructor(props) {
        super(props);
        this.state = {
            selectedCategory: 'all',
            projects: [
                { id: 1, title: 'RO(Reverese Osmosis)', description: '', category: 'RO(Reverese Osmosis)', imgSrc: 'assets/img/projectsimg/ro.png' },
                { id: 2, title: 'RO(Reverese Osmosis)', description: '', category: 'RO(Reverese Osmosis)', imgSrc: 'assets/img/projectsimg/ro.png' },
                { id: 3, title: 'Water Purifier', description: '', category: 'Water Purifier', imgSrc: 'assets/img/projectsimg/waterpurifier.jpg' },
                { id: 4, title: 'Water Purifier', description: '', category: 'Water Purifier', imgSrc: 'assets/img/projectsimg//waterpurifier.jpg' },
                //{ id: 5, title: 'Centrifugal Dryer', description:'', category: 'Centrifugal Dryer', imgSrc: 'https://via.placeholder.com/400x150' },
                //{ id: 6, title: 'Centrifugal Dryer', description: '', category: 'Centrifugal Dryer', imgSrc: 'https://via.placeholder.com/400x150' }
            ],
            categories: ['all', 'RO(Reverese Osmosis)', 'Water Purifier', ]
        };
    }

    handleCategoryChange = (category) => {
        this.setState({ selectedCategory: category });
    }

   

    render() {
        const { selectedCategory, projects, categories } = this.state;
        const filteredProjects = selectedCategory === 'all' ? projects : projects.filter(project => project.category === selectedCategory);

        return (
            <>

                <div className="container project-container">
                    <h2 className="section-heading">Our Projects</h2>
                    <div className="category-buttons">
                        {categories.map(category => (
                            <button
                                key={category}
                                className={`btn ${selectedCategory === category ? 'btn-primary' : 'btn-secondary'}`}
                                onClick={() => this.handleCategoryChange(category)}
                            >
                                {category}
                            </button>
                        ))}
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-deck">
                                {filteredProjects.map(project => (
                                    <div key={project.id} className="card project-card">
                                        <img src={project.imgSrc} alt={project.title} className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">{project.title}</h5>
                                            <p className="card-text">{project.description}</p>
                                            <Link to="#" className="btn btn-custom">Learn More</Link>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>



                </>
        );
    }
}
